<div class="header-content w-100 d-flex align-items-center justify-content-between">
  <div class="header-left d-flex align-items-center flex-grow-1 min-width-0 ms-md-3">
    @if (user?.assignedTo?.length > 1) {
      <span class="w-75">
        <select class="form-select form-select-sm" [(ngModel)]="selectedCompany" (change)="onCompanyChange($event)">
          @for (company of user.assignedTo; track company) {
            <option [value]="company?.company?._id">
              {{ company?.company?.name }}
            </option>
          }
        </select>
      </span>
    }
    @if (user?.assignedTo?.length === 1) {
      <span class="text-truncate">
        <span class="heading-text fw-bold">
          {{ user?.assignedTo[0]?.company?.name | uppercase }}
        </span>
      </span>
    }
  </div>

  <div class="header-right me-1 me-md-5" (click)="signOut()">
    <fa-icon [icon]="faSignOut" class="signout-icon" ngbTooltip="Logout"></fa-icon>
  </div>
</div>